import type { GridCellParams, GridRowParams } from "@mui/x-data-grid-premium";
import type { DiffColumn, HistoryRecord } from "../repository";
import { when } from "util/support";

export const useChange = () => {
    const columnHasChange = ({ field, row }: Pick<GridCellParams, 'field' | 'row'>) => {
        const diff = row.differences?.[field as DiffColumn];

        return Boolean(
            diff &&
            !Object.is(diff.current, diff.previous)
        );
    };

    const rowHasChange = ({ row }: Pick<GridRowParams<HistoryRecord>, 'row'>): boolean => {
        const { differences } = row;

        return when(
            Boolean(differences),
            () => Object.keys(differences)
                .some(key => columnHasChange({ field: key, row })),
            false
        );
    };

    const getChangedDiffs = ({ row }: Pick<GridRowParams<HistoryRecord>, 'row'>): HistoryRecord['differences'] => {
        const { differences } = row;

        return Object.entries(differences ?? {})
            .reduce((acc, [key, value]) => (
                when(
                    columnHasChange({ field: key, row }),
                    () => ({
                        ...acc,
                        [key]: value
                    }),
                    acc
                )
            ), {} as HistoryRecord['differences']);
    };

    return {
        columnHasChange,
        rowHasChange,
        getChangedDiffs
    };
};

export default useChange;
